import van from "vanjs-core";
import {DateAndTimeFooter} from "../../components/date-and-time";
import {SmallTagWithDescriptions} from "../../components/small-tag-with-description";
import {temperature} from "../../state-variables";

const {div, span, img} = van.tags;

// Header pro mobilní zobrazení
export const Header = () => {

    return div({class: "header flex-row align-items-center justify-content-between"},
        DateAndTimeFooter,
        SmallTagWithDescriptions("Venkovní teplota", "Ambient Temperature", temperature, "°C"),
    )
}